export default "__VITE_ASSET__CvU8gYWq__"